import axios from 'axios'
import store from '@/store'

const baseURL = `${process.env.VUE_APP_BASE_URL}`;

// 创建axios实例
const service = axios.create({
  baseURL, // api 的 base_url
  timeout: 3000000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  (config) => {
    //此处优先读取接口配置
    config.headers['Content-Type']?'':config.headers['Content-Type'] = 'application/json'
    config.headers['Authorization'] = localStorage.getItem('token') || ''
    return config
  },
  (error) => {
    console.log(error)
    Promise.reject(error)
  }
)

// response 拦截器 待处理
// service.interceptors.response.use(
//   (response) => {
//     return response.data
//   },
//   (error) => {
//     if (error.response.data.code === "402001") {
//       location.href = './login'
//     }
//     debugger
//     Msg(error.response.message);
//     console.error('打印报错哦', error)
//     return error.response.data
//   }
// )

// 响应拦截器
service.interceptors.response.use(
  response => {
     const res = response.data
     if (res.code === 402001 ) {
        // location.href = './login'
        store.commit('global/SHOW_SNACKBAR', { text: '当前账号异常，请重新登录', color: 'error' })
      }
    return res
  },
  error => {
    console.log('err' + error)
    if (error && error.request) {
      const status = error.request['status']
      switch (status) {
        case 400:
          store.commit('global/SHOW_SNACKBAR', { text: error.response.data.message, color: 'error' })
          break
        case 422:
          store.commit('global/SHOW_SNACKBAR', { text: error.response.data.message, color: 'error' })
          break
        case 401:
          window.localStorage.clear();
          // location.href = './login'
          store.commit('global/SHOW_SNACKBAR', { text: error.response.data.message, color: 'error' })
          break
        case 403:
          store.commit('global/SHOW_SNACKBAR', { text: error.response.data.message, color: 'error' })
          break
        case 500:
          store.commit('global/SHOW_SNACKBAR', { text: error.response.data.message, color: 'error' })
          break
        default:
          break
      }
    } else {
      store.commit('global/SHOW_SNACKBAR', { text: error.response.data.message, color: 'error' })
    }

    return Promise.reject(error)
  }
)
export default service
